export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <span className="text-2xl font-bold font-heading text-primary-400 whitespace-nowrap">
                51爆料
              </span>
              <p className="mt-3 text-sm text-background-300 leading-relaxed">
                51爆料每日大赛专区，每日更新51每日爆料、大赛排行与话题竞赛，紧跟每日热点，做你身边最及时的爆料聚合平台。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h4>
              <ul className="space-y-2.5">
                <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap">爆料合集</a></li>
                <li><a href="#features" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap">平台特色</a></li>
                <li><a href="#carousel" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap">焦点专题</a></li>
                <li><a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap">热度榜单</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">服务支持</h4>
              <ul className="space-y-2.5">
                <li><a href="#about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap">关于我们</a></li>
                <li><a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap">联系我们</a></li>
                <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap">常见问答</a></li>
                <li><a href="#app" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap">移动端</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">合作伙伴</h4>
              <p className="text-sm text-background-500 leading-relaxed">
                合作伙伴信息持续更新中，敬请期待。
              </p>
              <div className="mt-4 flex gap-3 flex-wrap">
                <span className="inline-block px-3 py-1 text-xs rounded-full bg-background-800 text-background-400 whitespace-nowrap">每日爆料</span>
                <span className="inline-block px-3 py-1 text-xs rounded-full bg-background-800 text-background-400 whitespace-nowrap">话题竞赛</span>
                <span className="inline-block px-3 py-1 text-xs rounded-full bg-background-800 text-background-400 whitespace-nowrap">热度排行</span>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 51爆料。本站内容仅供信息参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer no-underline whitespace-nowrap">用户协议</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer no-underline whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer no-underline whitespace-nowrap">内容声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}